export var ESCAPE_PATTERNS = [[/%/g, '\\%'], [/_/g, '\\_'], [/\[/g, '\\['], [/\]/g, '\\]']];